import { MessageNodeActionTypes } from '../types'

export default abstract class BaseSendMessageAction {
  type!: MessageNodeActionTypes
}
